var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vue-admin" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "page-space" }, [
      _c("div", { staticClass: "ui secondary segment" }, [
        _c(
          "form",
          {
            class: "ui small form" + (_vm.error ? " error" : ""),
            on: {
              submit: function($event) {
                _vm.saveModel($event)
              }
            }
          },
          [
            _c(
              "div",
              { class: "field" + (_vm.fieldErrors.title ? " error" : "") },
              [
                _c("label", { attrs: { for: "model-title" } }, [
                  _vm._v("Title")
                ]),
                _vm._v(" "),
                _c("error-tag", {
                  attrs: { error: _vm.fieldErrors.title, direction: "below" }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.model.title,
                      expression: "model.title"
                    }
                  ],
                  attrs: { id: "model-title", required: "" },
                  domProps: { value: _vm.model.title },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.model, "title", $event.target.value)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { class: "field" + (_vm.fieldErrors.type ? " error" : "") },
              [
                _c("label", { attrs: { for: "model-type" } }, [_vm._v("Type")]),
                _vm._v(" "),
                _c("error-tag", {
                  attrs: { error: _vm.fieldErrors.type, direction: "below" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "select-arrow" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.type,
                          expression: "model.type"
                        }
                      ],
                      attrs: { id: "model-type", required: "" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.model,
                            "type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "in-the-news" } }, [
                        _vm._v("In the News")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "market-trends" } }, [
                        _vm._v("Market Trends")
                      ]),
                      _vm._v(" "),
                      _c(
                        "option",
                        { attrs: { value: "research-publications" } },
                        [_vm._v("Research Publications")]
                      ),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "top-transactions" } }, [
                        _vm._v("Top Transactions")
                      ]),
                      _vm._v(" "),
                      _c(
                        "option",
                        { attrs: { value: "awards-recognitions" } },
                        [_vm._v("Awards & Recognitions")]
                      )
                    ]
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { class: "field" + (_vm.fieldErrors.date ? " error" : "") },
              [
                _c("label", { attrs: { for: "model-date" } }, [_vm._v("Date")]),
                _vm._v(" "),
                _c("error-tag", {
                  attrs: {
                    error: _vm.fieldErrors.datefield,
                    direction: "below"
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.model.datefield,
                      expression: "model.datefield"
                    }
                  ],
                  attrs: { id: "model-datefield", type: "date" },
                  domProps: { value: _vm.model.datefield },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.model, "datefield", $event.target.value)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class:
                  "field medium-field" + (_vm.fieldErrors.blurb ? " error" : "")
              },
              [
                _c("label", { attrs: { for: "model-blurb" } }, [
                  _vm._v("Blurb")
                ]),
                _vm._v(" "),
                _c("error-tag", {
                  attrs: { error: _vm.fieldErrors.blurb, direction: "below" }
                }),
                _vm._v(" "),
                _c(
                  "ckeditor",
                  {
                    attrs: { id: "model-blurb" },
                    model: {
                      value: _vm.model.blurb,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "blurb", $$v)
                      },
                      expression: "model.blurb"
                    }
                  },
                  [_vm._v("The short description shown on the index page.")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ui segment" }, [
              _c("div", { staticClass: "ui segment secondary" }, [
                _c("label", [_vm._v("Link action")]),
                _vm._v(" "),
                _c("div", { staticClass: "inline fields" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("div", { staticClass: "ui radio checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.link_action,
                            expression: "link_action"
                          }
                        ],
                        attrs: {
                          id: "model-link-link",
                          type: "radio",
                          name: "link-action",
                          value: "link"
                        },
                        domProps: { checked: _vm._q(_vm.link_action, "link") },
                        on: {
                          change: function($event) {
                            _vm.link_action = "link"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "model-link-link" } }, [
                        _vm._v("Link")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field" }, [
                    _c("div", { staticClass: "ui radio checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.link_action,
                            expression: "link_action"
                          }
                        ],
                        attrs: {
                          id: "model-link-post",
                          type: "radio",
                          name: "link-action",
                          value: "body"
                        },
                        domProps: { checked: _vm._q(_vm.link_action, "body") },
                        on: {
                          change: function($event) {
                            _vm.link_action = "body"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "model-link-post" } }, [
                        _vm._v("Post body")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field" }, [
                    _c("div", { staticClass: "ui radio checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.link_action,
                            expression: "link_action"
                          }
                        ],
                        attrs: {
                          id: "model-link-file",
                          type: "radio",
                          name: "link-action",
                          value: "file"
                        },
                        domProps: { checked: _vm._q(_vm.link_action, "file") },
                        on: {
                          change: function($event) {
                            _vm.link_action = "file"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "model-link-file" } }, [
                        _vm._v("Choose or upload a file")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field" }, [
                    _c("div", { staticClass: "ui radio checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.link_action,
                            expression: "link_action"
                          }
                        ],
                        attrs: {
                          id: "model-link-none",
                          type: "radio",
                          name: "link-action",
                          value: "none"
                        },
                        domProps: { checked: _vm._q(_vm.link_action, "none") },
                        on: {
                          change: function($event) {
                            _vm.link_action = "none"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "model-link-none" } }, [
                        _vm._v("None")
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ui segment secondary" }, [
                _vm.link_action === "link"
                  ? _c(
                      "div",
                      {
                        class: "field" + (_vm.fieldErrors.link ? " error" : "")
                      },
                      [
                        _c("label", { attrs: { for: "model-link" } }, [
                          _vm._v("Link")
                        ]),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.link,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.link,
                              expression: "model.link"
                            }
                          ],
                          attrs: { id: "model-link", required: "" },
                          domProps: { value: _vm.model.link },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.model, "link", $event.target.value)
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.link_action === "body"
                  ? _c(
                      "div",
                      {
                        class: "field" + (_vm.fieldErrors.body ? " error" : "")
                      },
                      [
                        _c("label", { attrs: { for: "model-body" } }, [
                          _vm._v("Body")
                        ]),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.body,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "media-resources-body" },
                          [
                            _c("ckeditor", {
                              attrs: { id: "model-body" },
                              model: {
                                value: _vm.model.body,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "body", $$v)
                                },
                                expression: "model.body"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.link_action === "file"
                  ? _c(
                      "div",
                      {
                        class:
                          "field" + (_vm.fieldErrors.link_file ? " error" : "")
                      },
                      [
                        _c("label", [_vm._v("File")]),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.link_file,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          ref: "linkfileupload",
                          attrs: { type: "file", required: "" },
                          on: { change: _vm.clearLinkExisting }
                        }),
                        _vm._v(" "),
                        _c("choose-file", {
                          attrs: { folder: "media-resources" },
                          on: { picked: _vm.linkExistingFile }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.link_action === "none"
                  ? _c("div", { class: "field" })
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui segment" }, [
              _c("label", [_vm._v("Photo")]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "ui grid" }, [
                _c("div", { staticClass: "ten wide column" }, [
                  _c(
                    "div",
                    {
                      class: "field" + (_vm.fieldErrors.photo ? " error" : "")
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "ui segment secondary" },
                        [
                          _c("error-tag", {
                            attrs: {
                              error: _vm.fieldErrors.photo,
                              direction: "below"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            ref: "filepicker",
                            attrs: { type: "file", id: "model-photo-upload" },
                            on: { change: _vm.imagePreview }
                          }),
                          _vm._v(" "),
                          _c("choose-file", {
                            attrs: {
                              folder: "media-resources",
                              photo_only: true
                            },
                            on: { picked: _vm.chooseExistingFile }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "six wide column" }, [
                  _c("div", { staticClass: "ui segment secondary" }, [
                    _c("img", {
                      attrs: {
                        alt: "default",
                        src: _vm.model.upload
                          ? _vm.model.upload.preview
                          : _vm.model.photo
                            ? _vm.model.photo.folder + _vm.model.photo.file
                            : "/img/default.jpg?v=1"
                      }
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.model.photo || _vm.model.upload
                      ? _c(
                          "button",
                          {
                            staticClass: "ui small grey button",
                            attrs: { type: "button" },
                            on: { click: _vm.clearPhoto }
                          },
                          [
                            _c("i", { staticClass: "erase icon" }),
                            _vm._v(" Clear photo")
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.error
              ? _c("error-display", { attrs: { error: _vm.error } })
              : _vm._e(),
            _vm._v(" "),
            _c("p", [
              _c(
                "button",
                {
                  class:
                    "ui small green submit button" +
                    (_vm.saving ? " loading " : ""),
                  attrs: { type: "submit" }
                },
                [_vm._v("Save Media")]
              )
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-banner" }, [
      _c("h1", [_vm._v("Create Media & Resources — Admin")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v("Recommended file size is 400px wide by 150-300px tall.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a21c9c74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a21c9c74","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/admin/media-resources/create.vue
// module id = 537
// module chunks = 0